const SCALE = 1
const WIDTH = 16 * SCALE
const HEIGHT = 20 * SCALE

const fingerWidth = WIDTH/5
const fingerRadius = fingerWidth/2
const wristWidth = WIDTH/2
const palmHeight = HEIGHT/2


function PresenceRenderer(ctx) {
  const { Path2D } = ctx.canvas.ownerDocument.defaultView

  return {
    renderArrowPresence,
    renderEllipseToolPresence: renderArrowPresence,
    renderPenEraserToolPresence: renderArrowPresence,
    renderPenToolPresence: renderArrowPresence,
    renderPolygonToolPresence: renderArrowPresence,
    renderPolylineToolPresence: renderArrowPresence,
    renderRectangleToolPresence: renderArrowPresence,
    renderTextCreatorPresence: renderArrowPresence,
    renderTextEditorPresence: renderArrowPresence,
    renderMovePresence: renderArrowPresence,
    renderOpenHandPresence({ x, y }, color) {
      ctx.save()
      Object.assign(ctx, {
        strokeStyle: color,
        fillStyle: 'white',
        lineWidth: 1,
      })
      const path = new Path2D(`M ${x},${y} ` + getOpenHandPath())
      fillAndStrokePath(path, color)
      ctx.restore()
    },
    renderClosedHandPresence({ x, y }, color) {
      ctx.save()
      Object.assign(ctx, {
        strokeStyle: color,
        fillStyle: 'white',
        lineWidth: 1,
      })
      const path = new Path2D(`M ${x},${y} ` + getClosedHandPath())
      fillAndStrokePath(path, color)
      ctx.restore()
    },
  }

  function renderArrowPresence({ x, y }, color) {
    ctx.save()
    Object.assign(ctx, {
      lineJoin: 'round',
      strokeStyle: color,
      fillStyle: 'white',
      lineWidth: 1,
    })
    const path = new Path2D(`M ${x},${y} ` + getArrowPath())
    fillAndStrokePath(path, color)
    ctx.restore()
  }

  function fillAndStrokePath(path, color) {
    Object.assign(ctx, {
      shadowBlur: 8,
      shadowColor: color,
      shadowOffsetX: 2,
      shadowOffsetY: 2,
    })
    ctx.fill(path)
    Object.assign(ctx, {
      shadowBlur: null,
      shadowColor: null,
      shadowOffsetX: null,
      shadowOffsetY: null,
    })
    ctx.stroke(path)
  }
}


function getArrowPath() {
  return [
    // slant down-right from tip
    `l ${WIDTH * 0.625} ${HEIGHT * 0.55}`,
    // cut back in to shaft
    `l ${WIDTH * -0.29} ${HEIGHT * -0.04}`,
    // top of shaft
    `l ${WIDTH * 0.11} ${HEIGHT * 0.22}`,
    // base of shaft
    `l ${WIDTH * -0.14} ${HEIGHT * 0.04}`,
    // bottom of shaft
    `l ${WIDTH * -0.11} ${HEIGHT * -0.22}`,
    // move down-left to bottom edge of head
    `l ${WIDTH * -0.19} ${HEIGHT * 0.19}`,
    // move back to tip
    `l 0 ${HEIGHT * -0.74}`,
    'z',
  ].join(' ')
}

function getClosedHandPath() {
  const thumbHeight = (HEIGHT/3 - fingerRadius) * 0.5
  const middleHeight = HEIGHT/15
  const pointerHeight = HEIGHT * 0.05
  const ringHeight = HEIGHT * 0.05
  const littleHeight = HEIGHT * 0.025
  const knuckle = `a ${fingerRadius} ${fingerRadius} 180 0 1 ${fingerWidth} 0`
  return [
    // move to left side of wrist
    `m ${-wristWidth/2}, ${palmHeight}`,
    // left palm
    `q ${-WIDTH/4}, ${-HEIGHT/8}, ${-(wristWidth)/2 + fingerRadius}, ${-palmHeight}`,
    // thumb
    `a ${fingerRadius} ${fingerRadius} 90 0 1 ${fingerRadius} 0`,
    `v ${thumbHeight}`,
    // pointer
    `v ${-thumbHeight - pointerHeight}`,
    knuckle,
    `v ${pointerHeight}`,
    // middle
    `v ${-middleHeight}`,
    knuckle,
    `v ${middleHeight}`,
    // ring
    `v ${-ringHeight}`,
    knuckle,
    `v ${ringHeight}`,
    // little
    `v ${littleHeight}`,
    `v ${-littleHeight}`,
    knuckle,
    // right palm
    `q ${0}, ${palmHeight}, -${(WIDTH - wristWidth)/2}, ${palmHeight}`,
    // base
    'z',
  ].join(' ')
}

function getOpenHandPath() {
  const thumbHeight = HEIGHT/3 - fingerRadius
  const middleHeight = HEIGHT/2 - fingerRadius - 1
  const pointerHeight = HEIGHT/2 - fingerRadius*2 - HEIGHT/20
  const ringHeight = HEIGHT/2 - fingerRadius*2 - HEIGHT/20
  const littleHeight = HEIGHT/3 - fingerWidth*0.75
  const fingerTip = `a ${fingerRadius} ${fingerRadius} 180 0 1 ${fingerWidth} 0`
  return [
    // move to left side of wrist
    `m -${wristWidth/2}, ${palmHeight}`,
    // left palm
    `q ${-WIDTH/8}, ${0}, -${(WIDTH - wristWidth)/2}, ${-palmHeight + thumbHeight/2}`,
    // thumb
    `v -${thumbHeight}`,
    fingerTip,
    `v ${thumbHeight}`,
    // pointer
    `v -${thumbHeight + pointerHeight - fingerRadius}`,
    fingerTip,
    `v ${pointerHeight}`,
    // middle
    `v -${middleHeight}`,
    fingerTip,
    `v ${middleHeight}`,
    // ring
    `v -${ringHeight}`,
    fingerTip,
    `v ${ringHeight + HEIGHT/20}`,
    // little
    `v 0,-${littleHeight}`,
    fingerTip,
    `v ${littleHeight}`,
    // right palm
    `q ${0}, ${palmHeight}, -${(WIDTH - wristWidth)/2}, ${palmHeight}`,
    // base
    'z',
  ].join(' ')
}

module.exports = PresenceRenderer
